import { useRef, useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { useFeatureFlagContext } from '../feature-flags/FeatureFlagProvider';
import { GlobalTopBar } from './GlobalTopBar';
import { buildVisibleNavigation } from './navigation';
import { RouteAccessBoundary } from './RouteAccessBoundary';
import { WorkspaceSideNav } from './WorkspaceSideNav';
import './console.css';

export function AppShell() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const menuTrigger = useRef<HTMLElement | null>(null);
  const { role } = useAuth();
  const { flags } = useFeatureFlagContext();
  const navigation = role ? buildVisibleNavigation(role, flags) : null;

  const openDrawer = () => {
    menuTrigger.current =
      document.activeElement instanceof HTMLElement ? document.activeElement : null;
    setDrawerOpen(true);
  };

  return (
    <div className="gateway-shell console-shell">
      {navigation && <GlobalTopBar navigation={navigation} onOpenMenu={openDrawer} />}
      <div className="console-shell-body">
        {navigation && (
          <WorkspaceSideNav className="console-sidebar-desktop" navigation={navigation} />
        )}
        <main className="gateway-main console-main">
          <RouteAccessBoundary>
            <Outlet />
          </RouteAccessBoundary>
        </main>
      </div>
      {navigation && (
        <Dialog.Root onOpenChange={setDrawerOpen} open={drawerOpen}>
          <Dialog.Portal>
            <Dialog.Overlay className="console-drawer-overlay" />
            <Dialog.Content
              aria-describedby={undefined}
              className="console-drawer"
              onCloseAutoFocus={(event) => {
                event.preventDefault();
                menuTrigger.current?.focus();
              }}
            >
              <Dialog.Title className="console-sr-only">工作区导航</Dialog.Title>
              <WorkspaceSideNav navigation={navigation} onNavigate={() => setDrawerOpen(false)} />
              <Dialog.Close aria-label="关闭导航" className="console-drawer-close">
                ×
              </Dialog.Close>
            </Dialog.Content>
          </Dialog.Portal>
        </Dialog.Root>
      )}
    </div>
  );
}
